<template>
<div>
    <div v-if="!isMobile">
        
        <div class="div_001">
            <div class="div_001_001">
                <div @click="nav_001('')"></div>
                <div>
                    <div @click="nav_001('Features')">     Features     </div>
                    <div @click="nav_001('Applications')"> Applications </div>
                    <div @click="nav_001('Projects')">     Projects     </div>
                    <div @click="nav_001('About')">        About Us     </div>
                    <div @click="nav_001('Contact')">      Contact Us   </div>
                </div>
                <div>
                    <div></div> <div> EN </div>
                </div>
            </div>
        </div>
        
        <div class="div_002">
            <div class="div_002_001">
                <div @click="nav_001('')"></div> <div><div><div></div></div></div> <div> Applications </div>
            </div>
        </div>
        
        <div class="div_003" :style="{ 'height' : screenHeight - 168 + 'px' }">
            <div class="div_003_001">
                <div :style="{ 'height' : screenHeight - 200 + 'px' }">
                    
                    <div class="div_003_001_m"></div>
                    
                    <div class="div_003_001_l">
                        <div></div> <span>Learn more</span>
                    </div>
                    
                    <div class="div_003_001_r">
                        <div class="iconfont_002"> Versatile Craft. </div>
                        <div class="iconfont_002"> Endless Aesthetic Possibilities. </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="div_004">
            <div class="div_004_001">
                <div>
                    <div>
                        <span class="iconfont_002"> Hospital/Laboratory </span>
                        <span>
                            Complies with strict fire safety standards for healthcare environments. Resistant to frequent disinfection, moisture, bacteria, and chemical corrosion. Easy to cut and drill for seamless integration with medical equipment, handrails, and signage. The dense surface resists dust buildup and bacterial growth, supporting high-frequency sanitation.
                        </span>
                    </div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                    <div>
                        <span class="iconfont_002"> Airport </span>
                        <span>
                            Designed for high-traffic transportation environments, meeting strict fire safety standards. Its durable, moisture-resistant structure withstands constant passenger flow, while the dense surface resists stains and wear. The panels are easy to cut and install, enabling seamless integration with signage, architectural finishes, and large-scale terminal interiors.
                        </span>
                    </div>
                </div>
                <div>
                    <div>
                        <span class="iconfont_002"> Sports Facilities </span>
                        <span>
                            Resistant to sweat and high-humidity environments, maintaining a clean and dry surface over time. Available in vibrant colors or natural texture finishes to enhance the atmosphere of sports and activity spaces.
                        </span>
                    </div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                    <div>
                        <span class="iconfont_002"> Commercial Area </span>
                        <span>
                            Ideal for modern commercial environments including shopping centers, retail stores, and office interiors. The panels combine fire safety, durability, and easy maintenance for high-traffic spaces. With a wide range of colors and natural textures available, they provide designers with flexible options to create refined, contemporary commercial interiors.
                        </span>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    
    <div v-if="isMobile">
        
        <div class="div_mobile_001">
            <div class="div_mobile_001_001">
                <div class="div_mobile_001_001_l" @click="nav_001('')"></div>
                <div class="div_mobile_001_001_r" @click="fun_002()">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        
        <div id="div_mobile_menu" class="div_mobile_menu" :style="{ height: screenHeight + 'px', top: -screenHeight + 'px' }">
            <div @click="nav_001('Features')">     Features     </div>
            <div @click="nav_001('Applications')"> Applications </div>
            <div @click="nav_001('Projects')">     Projects     </div>
            <div @click="nav_001('About')">        About Us     </div>
            <div @click="nav_001('Contact')">      Contact Us   </div>
            <div :style="{ 'height' : screenHeight - 438 + 'px' }"  @click="fun_002()"></div>
        </div>
        
        <div class="div_mobile_002">
            <div class="div_mobile_002_001">
                <div @click="nav_001('')"></div> <div><div><div></div></div></div> <div> Applications </div>
            </div>
        </div>
        
        <div class="div_mobile_003">
            <div class="div_mobile_003_001">
                <div>
                    
                    <div class="div_mobile_003_001_m"></div>
                    
                    <div class="div_mobile_003_001_l">
                        <div></div> <span>Learn more</span>
                    </div>
                    
                    <div class="div_mobile_003_001_r">
                        <div class="iconfont_002"> Versatile Craft. </div>
                        <div class="iconfont_002"> Endless Aesthetic Possibilities. </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="div_mobile_004">
            <div class="div_mobile_004_001">
                <div>
                    <div></div>
                    <div>
                        <span class="iconfont_002"> Hospital/Laboratory </span>
                        <span>
                            Complies with strict fire safety standards for healthcare environments. Resistant to frequent disinfection, moisture, bacteria, and chemical corrosion. Easy to cut and drill for seamless integration with medical equipment, handrails, and signage. The dense surface resists dust buildup and bacterial growth, supporting high-frequency sanitation.
                        </span>
                    </div>
                </div>
                <div>
                    <div></div>
                    <div>
                        <span class="iconfont_002"> Airport </span>
                        <span>
                            Designed for high-traffic transportation environments, meeting strict fire safety standards. Its durable, moisture-resistant structure withstands constant passenger flow, while the dense surface resists stains and wear. The panels are easy to cut and install, enabling seamless integration with signage, architectural finishes, and large-scale terminal interiors.
                        </span>
                    </div>
                </div>
                <div>
                    <div></div>
                    <div>
                        <span class="iconfont_002"> Sports Facilities </span>
                        <span>
                            Resistant to sweat and high-humidity environments, maintaining a clean and dry surface over time. Available in vibrant colors or natural texture finishes to enhance the atmosphere of sports and activity spaces.
                        </span>
                    </div>
                </div>
                <div>
                    <div></div>
                    <div>
                        <span class="iconfont_002"> Commercial Area </span>
                        <span>
                            Ideal for modern commercial environments including shopping centers, retail stores, and office interiors. The panels combine fire safety, durability, and easy maintenance for high-traffic spaces. With a wide range of colors and natural textures available, they provide designers with flexible options to create refined, contemporary commercial interiors.
                        </span>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isMobile     : false,
            screenHeight : 0,
            scrollTop    : 0,
        };
    },
    created() {
        // 监听；
        window.addEventListener('resize', this.checkIsMobile);
        // window.addEventListener('scroll', this.checkScrollTop);
    },
    mounted() {
        let that = this;
        
        document.title = '';
        
        this.checkIsMobile();
        this.checkScreenHeight();
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIsMobile);
        // window.removeEventListener('scroll', this.checkScrollTop);
    },
    methods: {
        // 检测移动设备；
        checkIsMobile() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let isMobile_001 = width <= 768;
            
            const userAgent = window.navigator.userAgent;
            let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
             
            this.isMobile = isMobile_001 || isMobile_002;
            
            // console.log("移动设备判断方式一：", isMobile_001);
            // console.log("移动设备判断方式二：", isMobile_002);
        },
        // 检测屏幕高度；
        checkScreenHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight;
            this.screenHeight = height;
        },
        // 事件 - 导航栏跳转；
        nav_001( param ) {
            this.$router.push( "/" + param );
        },
        // 事件 - 移动端导航栏；
        fun_002( ) {
            
            let that = this;
            
            let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
            
            console.log(offset);
            
            if ( offset < 0 ) {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) + 10 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] >= 0 ) {
                        
                        document.getElementById( 'div_mobile_menu' ).style.top = '0px';
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            } else {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) - 10 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] <= -that.screenHeight ) {
                    
                        document.getElementById( 'div_mobile_menu' ).style.top = -that.screenHeight;
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            }
        },
    }
};
</script>

<style scoped>
/*** ************************************************* ***/

.div_001 {
    width: 100%;
    height: 88px;
    
    color: #F7F4EC;
    background-color: #151513;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_001_001 {
    width: 1440px;
    height: 100%;
    
    background-color: #151513;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_001_001 > div:first-child {
    width: 137px;
    height: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: absolute;
    top: 28px;
    left: 32px;
}

.div_001_001 > div:nth-child(2) {
    width: 885px;
    
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_001 > div:nth-child(2) > div {
    cursor: pointer;
}

.div_001_001 > div:last-child {
    width: 54px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: absolute;
    top: 32px;
    right: 32px;
}

.div_001_001 > div:last-child > div:first-child {
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/image_000_003.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
    top: 0.5px;
}

.div_001_001 > div:last-child > div:last-child {
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_002_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_002_001 > div:nth-child(2) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_002_001 > div:nth-child(2) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_002_001 > div:nth-child(2) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_002_001 > div:last-child {
    width : 200px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_003 {
    width: 100%;
    background-color: #151513;
}

.div_003_001 {
    width: 1440px;
    height: 100%;
    
    margin: 0 auto;
}

.div_003_001 > div {
    width: 1376px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    background-image : url('../assets/03 Applications/cover.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_003_001_l {
    width : 400px;
    height: 140px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    color: #F7F4EC;
    background-color: #151513;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_003_001_l > div {
    width : 24px;
    height: 24px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_006.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_003_001_l > span {
    margin-left: 12px;
    margin-bottom: 2.5px;
    cursor: pointer;
}

.div_003_001_r {
    width : 550px;
    height: 104px;
    
    color: #F7F4EC;
    
    font-size: 36px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : flex-end;
    
    position: absolute;
    bottom: 45px;
    right: 40px;
}

.div_003_001_m {
    width : 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.2);
    
    position: absolute;
    top: 0px;
    left: 0px;
}

/*** ************************************************* ***/

.div_004 {
    width: 100%;
    height: 1664px;
    
    background-color: #F7F4EC;
}

.div_004_001 {
    width: 752px;
    height: 100%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div {
    width: 752px;
    height: 360px;
    
    margin-top: 32px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_004_001 > div:first-child {
    margin-top: 64px;
}

.div_004_001 > div > div {
    width: 360px;
    height: 360px;
    
    color: #2F2F2F;
    border-radius: 8px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_004_001 > div > div > span:first-child {
    font-size: 36px;
    font-weight: 600;
    
    margin-top: 42px;
}

.div_004_001 > div > div > span:last-child {
    font-size: 16px;
    text-align: justify;
    
    margin-top: 32px;
}

.div_004_001 > div:first-child > div:last-child {
    background-image : url('../assets/03 Applications/image_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_004_001 > div:nth-child(2) > div:first-child {
    background-image : url('../assets/03 Applications/image_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 135%;
}

.div_004_001 > div:nth-child(3) > div:last-child {
    background-image : url('../assets/03 Applications/image_003.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_004_001 > div:last-child > div:first-child {
    background-image : url('../assets/03 Applications/image_004.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

/*** ************************************************* ***/
/*** ************************************************* ***/

.div_mobile_001 {
    width: 100%;
    height: 88px;
    
    background-color: #151513;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_mobile_001_001 {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_001_l {
    width: 137px;
    height: 32px;
    
    background-image : url('../assets/image_000_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_001_r {
    width: 40px;
    height: 40px;
    
    background-color: #F7F4EC;
    
    border-radius: 4px;
        
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_001_001_r > div {
    width: 28px;
    height: 3px;
    
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    
    border-radius: 2px;
    
    background-color: #151513;
}

.div_mobile_menu {
    width: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    position: fixed;
    left: 0px;
    
    z-index: 999999;
}

.div_mobile_menu > div {
    width: 100%;
    height: 70px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    
    background-color: #F7F4EC;
}

.div_mobile_menu > div:first-child {
    margin-top: 88px;
}

.div_mobile_menu > div:last-child {
    width: 100%;
    
    background-color: rgba(0, 0, 0, 0);
}

/*** ************************************************* ***/

.div_mobile_002 {
    width: 100%;
    height: 168px;
    
    color: #F7F4EC;
    background-color: #151513;
}

.div_mobile_002_001 {
    width: 90%;
    height: 100%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_002_001 > div:first-child {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_005.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_002_001 > div:nth-child(2) {
    width: 24px;
    height: 24px;
    
    margin-top: 120px;
    margin-left: 22px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_002_001 > div:nth-child(2) > div {
    width : 0px;
    height: 0px;
    
    border-top : 8px solid transparent;
    border-left : 8px solid #F7F4EC;
    border-right : 8px solid transparent;
    border-bottom : 8px solid transparent;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    position: relative;
}

.div_mobile_002_001 > div:nth-child(2) > div > div {
    width : 0px;
    height: 0px;
    
    border-top : 5px solid transparent;
    border-left : 5px solid #151513;
    border-right : 5px solid transparent;
    border-bottom : 5px solid transparent;
    
    position: absolute;
    left: -8px;
}

.div_mobile_002_001 > div:last-child {
    width : 200px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 120px;
    margin-left: 5px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_mobile_003 {
    width: 100%;
    height: 520px;
    background-color: #151513;
}

.div_mobile_003_001 {
    width: 100%;
    height: 100%;
    
    margin: 0 auto;
}

.div_mobile_003_001 > div {
    width: 90%;
    height: 500px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    background-image : url('../assets/03 Applications/cover.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 150%;
    
    position: relative;
}

.div_mobile_003_001_l {
    width : 250px;
    height: 100px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    color: #F7F4EC;
    background-color: #151513;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_mobile_003_001_l > div {
    width : 24px;
    height: 24px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_006.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_003_001_l > span {
    margin-left: 12px;
    margin-bottom: 2.5px;
    cursor: pointer;
}

.div_mobile_003_001_r {
    width : 340px;
    height: 60px;
    
    position: absolute;
    bottom: 100px;
    right: 10px;
    
    color: #F7F4EC;
    
    font-size: 22px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : flex-end;
}

.div_mobile_003_001_m {
    width : 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.2);
    
    position: absolute;
    top: 0px;
    left: 0px;
}

/*** ************************************************* ***/

.div_mobile_004 {
    width: 100%;
    
    background-color: #F7F4EC;
}

.div_mobile_004_001 {
    width: 90%;
    
    margin: 0px auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div {
    width: 100%;
    height: 600px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_004_001 > div > div:first-child {
    width: 300px;
    height: 300px;
    
    color: #2F2F2F;
    border-radius: 8px;
    
    margin-top: 30px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div > div:last-child {
    width: 300px;
    height: 250px;
    
    color: #2F2F2F;
    border-radius: 8px;
    
    margin-top: 20px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div > div > span:first-child {
    font-size: 20px;
    font-weight: 600;
    
    margin-top: 20px;
}

.div_mobile_004_001 > div > div > span:last-child {
    font-size: 14px;
    text-align: justify;
    
    margin-top: 10px;
}

.div_mobile_004_001 > div:first-child > div:first-child {
    background-image : url('../assets/03 Applications/image_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_004_001 > div:nth-child(2) > div:first-child {
    background-image : url('../assets/03 Applications/image_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 135%;
}

.div_mobile_004_001 > div:nth-child(3) > div:first-child {
    background-image : url('../assets/03 Applications/image_003.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_004_001 > div:last-child > div:first-child {
    background-image : url('../assets/03 Applications/image_004.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

/*** ************************************************* ***/
</style>